<template>
  <div class="dashMenuWrapper">
    <div
      v-for="(elem, index) in config"
      :key="index"
      class="navBaseElem dashElem"
      :class="{ disable: !submissions_arr[index] }"
      @click.stop="handleClick(index)"
    >
      <span class="type">{{ $t(elem.i18n) }}</span>
      <span class="count">({{ submissions_arr[index] }})</span>
    </div>
  </div>
</template>
<script>
import dash_menu_mixin from "~/mixins/nav/dashMenu"

export default { mixins: [dash_menu_mixin] }
</script>
<style scoped>
.dashMenuWrapper {
  width: 100%;
}

.dashElem {
  padding: 12px 20px;
}

.navBaseElem .type {
  color: var(--color-black);
  font-size: var(--font-size-small);
  font-weight: 500;
}

.navBaseElem .count {
  color: var(--color-darker-grey);
  font-size: var(--font-size-eleven);
  font-weight: 500;
  margin-left: 4px;
}

div.disable {
  pointer-events: none;
  color: var(--color-grey);
}

.disable .type {
  color: var(--color-darker-grey);
}

div.disable span {
  color: var(--color-grey);
}

div.disable i {
  color: var(--color-grey);
}
div i {
  color: var(--color-dark-grey);
}
</style>
<style scoped src="~/components/nav/loggedIn/navBaseElem.css"></style>
